import { apiConfig } from "./config";

export const foodApi = {
  list: async () => {
    const response = await apiConfig.get("/api/front/chef/foods");
    return response;
  },
  updatePrice: async (foodId: string, price: number) => {
    const response = await apiConfig.patch(
      `/api/front/chef/food-price/${foodId}/${price}`,
    
    );
    return response;
  },
  estimate: async () => {
    const response = await apiConfig.get("/api/front/chef/estimate");
    return response;
  },
};
